import { makeStyles, tokens } from "@fluentui/react-components";
import { bundleIcon, OpenFilled, OpenRegular } from "@fluentui/react-icons";
import React from "react";

type Props = {
  text: string;
  href: string;
  onClick?: () => void;
  disabled?: boolean;
  target?: string;
};

const CombinedIcon = bundleIcon(OpenFilled, OpenRegular);

export const ExternalLink: React.FC<Props> = (props) => {
  const { text, href, onClick, disabled = false, target = "_blank" } = props;
  const styles = useStyles();

  const handleClick = () => {
    if (disabled) return;

    if (onClick) {
      onClick();
    }
  };

  return (
    <div className={`${styles.container} ${disabled ? styles.disabled : ""}`}>
      <a
        className={styles.link}
        href={href}
        target={target}
        rel="noopener noreferrer"
        onClick={handleClick}
        aria-disabled={disabled}
      >
        <span className={styles.text}>{text}</span>
        <span className={styles.iconWrapper}>
          <CombinedIcon className={styles.icon} />
        </span>
      </a>
    </div>
  );
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  text: {
    marginRight: tokens.spacingHorizontalXS,
    fontSize: tokens.fontSizeBase300,
  },
  iconWrapper: {
    display: "flex",
    alignItems: "center",
    fontSize: tokens.fontSizeBase300,
  },
  icon: {
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorBrandForegroundLink,
  },
  link: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: tokens.colorBrandForegroundLink,
    textDecoration: "none",
    width: "100%",
    cursor: "pointer",
    fontSize: tokens.fontSizeBase200,
    padding: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalSNudge}`,
    borderRadius: tokens.borderRadiusMedium,
    ":hover": {
      color: tokens.colorBrandForegroundLinkHover,
      backgroundColor: tokens.colorBrandBackgroundInvertedHover,
      textDecoration: "none",
    },
    "& span": {
      color: "inherit",
    },
  },
  disabled: {
    opacity: 0.5,
    cursor: "not-allowed",
    ":hover": {
      textDecoration: "none",
      backgroundColor: tokens.colorBrandBackgroundInverted,
      color: tokens.colorBrandForegroundLink,
    },
  },
});
